<template src="./Index.html">
</template>

<script>

export default {
  created() {

        },
        model: {
            prop: "employee",
        },
        props: ["employee"],
        computed: {},
  data() {
      return {}
  },
  methods: {
      nextStep() {
       this.$emit("back");
      },
      prevStep() {
          this.$emit("prevStep");
      },


  },
};
</script>
